export default __webpack_public_path__ + "static/media/running-icon.9f20849d.svg";